module.exports = __webpack_public_path__ + "img/Frame-4.c9658710.png";